<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <prices :link="`stocks`" :id="id" :title="`Цены`" />

    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
    <button v-if="item.product" class="btn mb-4" @click="showProduct">
      {{ "all_modifications" | setText("Все модификации") }}
    </button>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  components: {
    prices: () => import("./Prices"),
  },
  data: () => ({
    cardLink: "variants",
    cardSetLink: "variants",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "name",
        label: "Название (обмен данных)",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "modification_name",
        label: "Модификация",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "barcode",
        label: "Баркод",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "exchange_id",
        label: "Доп. идентификатор",
        type: "field",
        textType: "text",
      },
      {
        col: "col-12",
        label: "Товар",
        key: "product",
        type: "select",
        modal: "product",
        selectKey: "name",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
    showProduct() {
      let query = Object.assign({}, this.$route.query);

      if (query["item_product"] == this.item["product"]["id"]) {
        return false;
      }

      if (query["item_product"]) {
        delete query["item_product"];
      }

      query["item_product"] = this.item["product"]["id"];

      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
};
</script>
<style>
</style>
